import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export async function getMakeScheduleId() {
    return mutate(
        gql`
            mutation getIds {
                makeScheduleId {
                    scheduleId
                    clientCode
                }
            }
        `,
        {},
        { returns: "makeScheduleId" }
    )
}
